<!-- =========================================================================================
    File Name: ProgramEdit.vue
    Description: Редактирование партнерской программы
========================================================================================== -->


<template>
    <vs-prompt
        title="Редактирование программы"
        accept-text= "Сохранить"
        cancel-text = "Удалить"
        button-cancel = "border"
        @cancel="deleteProgram"
        @accept="submitProgram"
        :is-valid="validateForm"
        :active.sync="activePrompt">
        <div>
            <form>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-input v-validate="'required'" name="title" class="w-full mb-4 mt-5" placeholder="Название" v-model="programLocal.name" />
                        <vs-textarea rows="5" label="Описание" v-model="programLocal.descr" />
                        <vs-select v-model="programLocal.state" label="Статус" class="w-50">
                            <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in programStateList" />
                        </vs-select>
                    </div>
                </div>

            </form>
        </div>
    </vs-prompt>
</template>

<script>
import modulePartner          from '@/store/partner/modulePartner.js'

export default {
    props: {
        displayPrompt: {
            type: Boolean,
            required: true,
        },
        programId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            programLocal: Object.assign({}, this.$store.getters["partner/getProgram"](this.programId)),
            programStateList: modulePartner.programStateList
        }
    },
    computed: {
        activePrompt: {
            get() {
                return this.displayPrompt;
            },
            set(value) {
                this.$emit('hideDisplayPrompt', value);
            }
        },
        validateForm() {
            return !this.errors.any() && this.programLocal.name != '';
        }
    },
    methods: {
        deleteProgram() {
            this.$store.dispatch("partner/deleteProgram", Object.assign({}, this.programLocal))
        },
        submitProgram() {
            this.$store.dispatch("partner/updateProgram", this.programLocal)
        }

    },
}
</script>
